import { Stack, Box } from "@mui/material";
import { css } from "glamor";
import React, { useRef, useState } from "react";

import ProductPageTemplate from "../../components/global/layout/ProductPageTemplate";
import LayoutContainer from "../../components/global/layout/LayoutContainer";
import Section from "../../components/global/layout/Section";
import { forms } from "../../constants/productPageData";
import InViewportCheck from '../../components/global/InViewportCheck';
import ScrollingTextItem from "../../components/global/Slider/ScrollingTextItem";
import Image from "../../components/global/layout/Image";
import { colours } from "../../constants/colourConstants";
import useSize from "@react-hook/size";
import ImageSlider from "../../components/global/Slider/ImageSlider";
import ScrollingTextAndSlider from "../../components/global/Slider/ScrollingSlider";


const Forms = ({ location }) => {

    /*const renderScrollingSection = () => {
        return (
            <LayoutContainer>
                <Section
                    {...css({
                        overflow: "visible",
                        marginBottom: "80px"
                    })}
                >
                    <ScrollingTextAndSlider
                        sections={forms.sections}
                    />
                </Section>
                <Section
                    {...css({
                        overflow: "visible"
                    })}
                >
                    <ScrollingTextAndSlider
                        sections={forms.sections}
                    />
                </Section>
            </LayoutContainer >
        )
    }*/

    return (
        <ProductPageTemplate
            page={forms}
            theme="purple"
            location={location}
        />
    )
}

export default Forms